import notification from '@atoms/Notification';
import { EMPTY_OBJ } from '@constants';
import useMutation from './useMutation';
import useQuery from './useQuery';

import api from '..';

export const useGameNotification = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['game-notifications', { id }], api.gameNotifications.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    gameNotification: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

const createGameNotificationsMutation = (apiCall) => (queryConfig = {}) =>
  useMutation(apiCall, {
    onSuccess: () => notification.success({ message: 'Successfully saved game notification ' }),
    onError: () => notification.error({ message: 'Failed to save game notification' }),
    ...queryConfig,
  });

export const useCreateGameNotification = createGameNotificationsMutation(api.gameNotifications.create);
export const useUpdateGameNotification = createGameNotificationsMutation(api.gameNotifications.update);
